import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../../../shared-zorro.module';
import { Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-template-render',
  standalone: true,
  imports: [CommonModule, SharedZorroModule],
  templateUrl: './render.component.html',
  styleUrl: './render.component.less',
})
export class RenderComponent {
  @Input() template: any;
  @Input() value: any = [];
  @Output() valueChange = new EventEmitter<any>();
  @Output() reportChange = new EventEmitter<any>();

  //设置默认值
  setDefault() {
    this.template.forEach((item: any) => {
      if (item.type === 'select') {
        this.value[item.index] = item.options[0];
      }
    });
  }

  selectChange(event: any, index: number) {
    this.valueChange.emit(this.value);
    this.reportChange.emit(this.getValue());
  }

  getValue() {
    //将value转换为字符串
    let str = '';
    this.template.forEach((item: any) => {
      if (item.type === 'text') {
        str += item.content;
      } else if (item.type === 'select') {
        str += this.value[item.index];
      } else if (item.type === 'input') {
        str += this.value[item.index];
      } else if (item.type === 'reference') {
        str += this.value[item.vIndex];
      }
    });
    return str;
  }

  //监听template的变化
  ngOnChanges(changes: SimpleChanges) {
    if (changes['template']) {
      this.setDefault();
    }
  }
}
